import React from 'react';
import TextField from '@mui/material/TextField';
import setCountryAction from '../../redux/actions/createReferenceActions/actionCountry';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    '&:hover': {
      borderColor: "rgb(0,191,255)",
    },
    '&.Mui-focused': {
      borderColor: "rgb(47, 79, 79)",
    },
  },
  '& .Mui-focused': {
    color: 'white',
  },
  width: 300,
  marginTop: 10,
  fontSize: 30,
  backgroundColor: 'rgba(19, 174, 236, 0.54)',
  fontWeight: 'bold'
});

// const styles = theme => ({
  
//   noOptions: {
//     color: "red",
//     backgroundColor: "pink"
//   },
//   root: {

//     "&:hover .MuiOutlinedInput-notchedOutline": {
//       borderColor: "rgb(0,191,255)"

//     },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: "rgb(47, 79, 79)"
//     },
//     "& .Mui-focused ": {
//       color: 'white'
//     }
// }
// });

class CountryForm extends React.Component {

  constructor(props) {
    super(props);

    if(this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
      this.state = {
        country: this.props.selectedReferenceData.country
      } 
        this.props.setCountryFunction(this.state.country);
      } else {
        this.state = {
          country: ''
        };
        this.props.setCountryFunction('defaultCountry');
      }
  }

  shouldComponentUpdate(nextProps, nextState) {

    if (this.props.country !== nextProps.country) {
        this.setState({ country: nextProps.country})
        return false;
    } else {
        return true;
    }
}

  render() {
    
    const { t } = this.props;

    return (

        <div>
          <div>
            <StyledTextField key={this.props.searchVal} disabled={true}  value={this.state.country} inputProps={{ maxLength: 30, style: {fontWeight: 'bold'}}} label={t('create_ref.country') + "*"} variant="outlined" error={this.props.countryError} 
              style={{ width: 300, marginTop: 10, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}/>
          </div>
        </div> 
    );
  }
}

function mapStateToProps(state) {
return {
  countryError: state.createRefState.countryError,
  selectedReferenceData: state.showRefState.selectedReferenceData
}
}
// set props to redux-store
function mapDispatchToProps(dispatch) {
  return {
    setCountryFunction: country => {
      dispatch(setCountryAction(country));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CountryForm));